import { createContext } from '~/v1/utils/context';

import { type SearchContextType } from './search.interface';

const SearchContext = createContext<SearchContextType>();

export const SearchContextProvider = SearchContext.Provider;

export const useSearchContext = SearchContext.useContext;
